"use client";

import HeroSection from "@/components/sections/landing/heroSection";
import SuuportSection from "@/components/sections/landing/suportSection";
import VisitSection from "@/components/sections/landing/visitSection";

export default function Home() {
  return (
    <main className="flex-1 container z-30 pb-10">
      <HeroSection />
      <VisitSection />
      <SuuportSection />
    </main>
  );
}
